module.exports = __webpack_public_path__ + "img/img_body_biz_mww_logo.e05772f6.png";